<div appFilterColumnsAutoFocus class="flex-column justify-content-center px-5 pb-5">
    <app-inventory-vehicles-table></app-inventory-vehicles-table>
</div>
